<template>
  <section id="team" class="team-section">
    <div class="team-container">
      <!-- 区域标签与标题 -->
      <div class="team-section-header">
        <div class="header-label">{{ $t('about.label') }}</div>
        <h2 class="team-title">{{ $t('about.title') }}</h2>
        <p class="team-subtitle">{{ $t('about.subtitle') }}</p>
      </div>

      <!-- 团队故事区块 -->
      <div class="team-story-section">
        <div class="story-block story-left">
          <div class="story-marker"></div>
          <div class="story-content">
            <h3 class="story-title">{{ $t('about.storyTitle') }}</h3>
            <p class="story-text">{{ $t('about.storyText1') }}</p>
            <p class="story-text">{{ $t('about.storyText2') }}</p>
            <p class="story-text">{{ $t('about.storyText3') }}</p>
            <p class="story-text">{{ $t('about.storyText4') }}</p>
          </div>
        </div>

        <!-- 简化的里程碑 -->
        <div class="milestones-block">
          <div class="milestone-item" v-for="(item, index) in translatedTimeline" :key="index">
            <div class="milestone-marker"></div>
            <div class="milestone-label">{{ item.title }}</div>
            <p class="milestone-desc">{{ item.description }}</p>
          </div>
        </div>
      </div>

      <!-- 核心团队成员 -->
      <div class="team-members-section">
        <div class="members-header">
          <h3 class="members-title">{{ $t('about.coreTeam') }}</h3>
          <p class="members-desc">{{ $t('about.teamDesc') }}</p>
        </div>

        <div class="members-grid">
          <div class="member-card" v-for="(member, index) in translatedTeamMembers" :key="index">
            <div class="member-header">
              <div class="member-avatar">
                <div class="avatar-circle">
                  <span class="avatar-initial">{{ member.name.charAt(0) }}</span>
                </div>
              </div>
              <div class="member-basic">
                <span class="member-tag">FOUNDER</span>
                <h4 class="member-name">{{ member.name }}</h4>
                <p class="member-role">{{ member.role }}</p>
              </div>
            </div>
            <p class="member-desc">{{ member.description }}</p>
            <div class="member-highlight">
              <span class="highlight-badge">{{ member.achievement }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 团队宣言 -->
      <div class="team-manifesto-section">
        <div class="manifesto-block">
          <h3 class="manifesto-title">{{ $t('about.manifesto') }}</h3>
          <div class="manifesto-quote">
            <p>
              {{ $t('about.manifestoText') }}
            </p>
            <div class="manifesto-sig">{{ $t('about.manifestoSig') }}</div>
          </div>
        </div>
      </div>

      <!-- 投资亮点 -->
      <!-- Unverified scorecard removed. -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'TeamSection',
  data() {
    return {
      timeline: [
        {
          titleKey: 'dreamGerm',
          descKey: 'dreamGermDesc'
        },
        {
          titleKey: 'techBreakthrough',
          descKey: 'techBreakthroughDesc'
        },
        {
          titleKey: 'productForm',
          descKey: 'productFormDesc'
        },
        {
          titleKey: 'fundingStart',
          descKey: 'fundingStartDesc'
        }
      ],
      teamMembers: [{ name: '夏祁轩', roleKey: 'ceoTitle' }]
    }
  },
  computed: {
    translatedTimeline() {
      return this.timeline.map(item => ({
        title: this.$t(`about.${item.titleKey}`),
        description: this.$t(`about.${item.descKey}`)
      }))
    },
    translatedTeamMembers() {
      return this.teamMembers.map(member => ({
        ...member,
        name: this.$t('about.founderName'),
        role: this.$t(`about.${member.roleKey}`),
        description: this.$t('about.founderDescription'),
        achievement: this.$t('about.founderAchievement')
      }))
    }
  },
  methods: {
    scrollToContact() {
      const element = document.getElementById('contact')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.team-section {
  padding: 120px 0 100px;
  background: #0B1220;
  position: relative;
  overflow: hidden;
}

.team-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(0, 217, 255, 0.02) 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, rgba(138, 43, 226, 0.02) 0%, transparent 50%);
  pointer-events: none;
}

.team-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
}

/* 标题区域 */
.team-section-header {
  text-align: center;
  margin-bottom: 80px;
}

.header-label {
  display: inline-block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 1rem;
  font-weight: 600;
}

.team-title {
  font-size: 2.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.8rem;
  letter-spacing: -0.5px;
}

.team-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 400;
  max-width: 600px;
  margin: 0 auto;
  letter-spacing: 0.3px;
}

/* 故事区块 */
.team-story-section {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 4rem;
  align-items: stretch;
  margin-bottom: 80px;
}

.story-block {
  background: #070B14;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 2.5rem;
  position: relative;
  padding-left: 3.5rem;
}

.story-left {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.story-block::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 12px 0 0 12px;
}

.story-marker {
  position: absolute;
  left: 1rem;
  top: 1.5rem;
  width: 6px;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
}

.story-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1.2rem;
}

.story-text {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.7;
  margin-bottom: 1rem;
}

/* 里程碑 */
.milestones-block {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.milestone-item {
  background: #070B14;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 1.5rem;
  position: relative;
  padding-left: 3rem;
  transition: all 0.3s ease;
}

.milestone-item:hover {
  border-color: rgba(255, 255, 255, 0.12);
  background: #0F1723;
}

.milestone-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.02) 100%);
  border-radius: 12px 0 0 12px;
}

.milestone-marker {
  position: absolute;
  left: 1.2rem;
  top: 1.5rem;
  width: 4px;
  height: 4px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
}

.milestone-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0.4rem;
}

.milestone-desc {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

/* 团队成员 */
.team-members-section {
  margin-bottom: 80px;
}

.members-header {
  text-align: center;
  margin-bottom: 3rem;
}

.members-title {
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.6rem;
}

.members-desc {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.6);
}

.members-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.member-card {
  background: #070B14;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 1.75rem 1.75rem 1.6rem;
  transition: all 0.3s ease;
}

.member-card:hover {
  border-color: rgba(255, 255, 255, 0.12);
  background: #0F1723;
}

.member-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.member-avatar {
  margin-right: 0.9rem;
}

.avatar-circle {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 0%, #38bdf8, #1d4ed8);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.8);
}

.avatar-initial {
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
}

.member-basic {
  display: flex;
  flex-direction: column;
}

.member-tag {
  align-self: flex-start;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(148, 163, 184, 0.9);
  margin-bottom: 0.15rem;
}

.member-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.1rem;
}

.member-role {
  font-size: 0.82rem;
  color: rgba(148, 163, 184, 0.95);
}

.member-desc {
  font-size: 0.88rem;
  color: rgba(226, 232, 240, 0.9);
  margin-bottom: 1.1rem;
  line-height: 1.7;
}

.member-highlight {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.highlight-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.16);
  border: 1px solid rgba(96, 165, 250, 0.4);
  font-size: 0.78rem;
  color: rgba(191, 219, 254, 0.96);
}

/* 宣言 */
.team-manifesto-section {
  background: linear-gradient(135deg, rgba(0, 217, 255, 0.05) 0%, rgba(138, 43, 226, 0.05) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 3rem;
  margin-bottom: 80px;
  text-align: center;
}

.manifesto-block {
  max-width: 700px;
  margin: 0 auto;
}

.manifesto-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 2rem;
}

.manifesto-quote p {
  font-size: 1rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1.5rem;
}

.manifesto-sig {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

/* 投资亮点 */
.investment-highlights-section {
  text-align: center;
}

.highlights-title {
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin-bottom: 3rem;
}

.highlights-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.5rem;
}

.highlight-stat {
  background: #070B14;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 2rem 1.5rem;
  position: relative;
  transition: all 0.3s ease;
}

.highlight-stat:hover {
  border-color: rgba(255, 255, 255, 0.12);
  background: #0F1723;
}

.highlight-stat::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.02) 100%);
  border-radius: 12px 0 0 12px;
}

.stat-number {
  font-size: 2.2rem;
  font-weight: 700;
  color: white;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 0.8rem;
  font-weight: 600;
}

.stat-desc {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.55);
  margin: 0;
}

/* 响应式 */
@media (max-width: 1024px) {
  .team-story-section {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .members-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.2rem;
  }

  .highlights-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.2rem;
  }

  .team-title {
    font-size: 2.2rem;
  }
}

@media (max-width: 640px) {
  .team-section {
    padding: 60px 0 50px;
  }

  .team-section-header {
    margin-bottom: 50px;
  }

  .team-title {
    font-size: 1.8rem;
  }

  .team-subtitle {
    font-size: 0.95rem;
  }

  .team-story-section {
    gap: 1.5rem;
  }

  .story-block,
  .milestone-item {
    padding: 1.5rem;
  }

  .member-card {
    padding: 1.5rem 1.5rem 1.4rem;
  }

  .member-name {
    font-size: 1rem;
  }

  .member-role {
    font-size: 0.8rem;
  }

  .member-desc {
    font-size: 0.8rem;
  }

  .members-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .manifesto-title {
    font-size: 1.4rem;
  }

  .manifesto-quote p {
    font-size: 0.95rem;
  }

  .highlights-title {
    font-size: 1.6rem;
    margin-bottom: 2rem;
  }

  .highlights-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .stat-number {
    font-size: 1.8rem;
  }

  .stat-label {
    font-size: 0.85rem;
  }
}
</style>
